import { useTranslation } from 'react-i18next';

const BestDealCard = ({ extraClasses = '' }: { extraClasses?: string }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`d-flex align-items-center justify-content-between fo-border-sm border-grey-200 rounded-3 p-3 ${extraClasses}`}
    >
      <p
        className="text-2 color-primary -regular me-3"
        dangerouslySetInnerHTML={{
          __html: t('office.show.requestVisitCard.bestDealCard'),
        }}
      />
      <img
        style={{ width: 56, height: 56 }}
        src="/media-remix/icons/best-deal.svg"
        alt="Best deal"
      />
    </div>
  );
};

export default BestDealCard;
